import { checkPermission } from "@ROM/Permissions/utils";

export const canListInvitations = (user, customerId = null) => checkPermission(user, "invitations:index", customerId);
export const canCreateInvitations = (user, customerId = null) => checkPermission(user, "invitations:create", customerId);
export const canResendInvitations = (user, customerId = null) => checkPermission(user, "invitations:resend", customerId);
export const canDeleteInvitations = (user, customerId = null) => checkPermission(user, "invitations:delete", customerId);
